import PropTypes from 'prop-types';
import React from 'react';
import { MobileOnly } from 'app-modules/application/components/MediaTargets';
import { withStyles } from '@material-ui/core/styles';
import Volume from './Volume';
import Seeker from './Seeker';
import { Share } from './share';
import Time from './Time';
import CCToggle from './CCToggle';
import { Settings } from './settings';
import { CollapsePlayer, ExitFullscreen, ExpandPlayer, Fullscreen, Play } from './buttons';
import s from './style/VideoControls';
import { withPlayer } from '../PlayerContext';
import { withNamespaces } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

const styles = {
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
};

class ChannelVideoControlsComp extends React.Component {
  static propTypes = {
    channel: PropTypes.shape({}).isRequired,
    hideTimes: PropTypes.bool,
    isTrivia: PropTypes.bool.isRequired,
    nowPlaying: PropTypes.shape({}).isRequired,
    player: PropTypes.shape({
      unfreezeOverlay: PropTypes.func.isRequired,
    }).isRequired,
    playerIsFullscreen: PropTypes.bool.isRequired,
    isAndroid: PropTypes.bool.isRequired,
    internalFullscreen: PropTypes.bool.isRequired,
    isFullscreen: PropTypes.bool.isRequired,
    enterFullscreen: PropTypes.func.isRequired,
    exitFullscreen: PropTypes.func.isRequired,
    haveCaptions: PropTypes.bool.isRequired,
    captionIndex: PropTypes.number.isRequired,
    toggleCaption: PropTypes.func.isRequired,
    showReset: PropTypes.bool.isRequired,
    onCCSettingsChange: PropTypes.func.isRequired,
    resetCCSettings: PropTypes.func.isRequired,
    isMuted: PropTypes.bool.isRequired,
    onCCMenuOpen: PropTypes.func.isRequired,
    onCCMenuClose: PropTypes.func.isRequired,
    onCCSetIndex: PropTypes.func.isRequired,
    onCCSubmenuOpen: PropTypes.func.isRequired,
    isCCMenuOpen: PropTypes.bool.isRequired,
    currentCCMenu: PropTypes.instanceOf(Array).isRequired,
    currentCCMenuName: PropTypes.string.isRequired,
    ccMenuSelectedIndexes: PropTypes.instanceOf(Array).isRequired,
    isCCEnabled: PropTypes.bool.isRequired,
    isFullscreenDisabled: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isEmbed: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      popupOpen: false,
      orientation: 'landscape',
    };
  }

  onOrientationChange = () => {
    if (window.innerWidth < 960) {
      this.setState({
        orientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait',
      });
    }
  };

  componentDidMount() {
    this.onOrientationChange();
    window.addEventListener('resize', this.onOrientationChange);
  }

  static defaultProps = {
    hideTimes: false,
  };

  componentWillUpdate(nextProps, nextState) {
    if (this.props.isAndroid && nextState.orientation !== this.state.orientation) {
      if (nextState.orientation === 'portrait') {
        this.props.player.exitFullscreen();
      } else {
        this.closePopup();
      }
    }
  }

  minutesLeft(stop) {
    const dStop = new Date(stop);
    return Math.round((dStop.getTime() - Date.now()) / (1000 * 60));
  }

  unfreezeOverlay = () => {
    setTimeout(() => this.props.player.unfreezeOverlay(), 0);
  };

  exitFullScreen = () => {
    const { player, exitFullscreen, exitFullscreenSplashPage } = this.props;
    exitFullscreen();
    player.exitFullscreen();
    exitFullscreenSplashPage();
  };

  openPopup = () => {
    this.setState({ popupOpen: true });
  };

  closePopup = () => {
    this.setState({ popupOpen: false });
  };

  render() {
    const {
      channel,
      hideTimes,
      isTrivia,
      nowPlaying,
      player,
      playerIsFullscreen,
      haveCaptions,
      isMuted,
      startShowTime,
      endShowTime,
      elapsed,
      duration,
      enterFullscreen,
      captionIndex,
      toggleCaption,
      showReset,
      onCCSettingsChange,
      resetCCSettings,
      onCCSubmenuOpen,
      onCCSetIndex,
      onCCMenuOpen,
      onCCMenuClose,
      isCCMenuOpen,
      currentCCMenu,
      currentCCMenuName,
      ccMenuSelectedIndexes,
      isCCEnabled,
      isFullscreenDisabled,
      isVisible,
      isMobile,
      isEmbed,
      isAndroid,
      isFullscreen,
      internalFullscreen,
      t,
    } = this.props;
    return (
      <s.videoControls>
        <s.centerControls>
          {!playerIsFullscreen && (
            <React.Fragment>
              <ExpandPlayer onClick={enterFullscreen} />
              <br />
              <div>{t('expand_popup_window')}</div>
            </React.Fragment>
          )}
        </s.centerControls>
        <s.middleControls>
          {player.autoPlayBlocked && <Play onClick={player.play} />}
        </s.middleControls>
        <s.bottomPanel
          playerIsFullscreen={playerIsFullscreen}
          isAndroid={isAndroid}
          isFullscreen={isFullscreen}
          onClick={(e) => e.stopPropagation()}
        >
          {playerIsFullscreen &&
            nowPlaying.start &&
            nowPlaying.stop &&
            !Number.isNaN(elapsed) &&
            !Number.isNaN(duration) && (
              <s.seekerWrapper hideTimes={hideTimes}>
                <Seeker
                  playerIsFullscreen={playerIsFullscreen}
                  startShowTime={startShowTime}
                  endShowTime={endShowTime}
                  position={elapsed}
                  duration={duration}
                  passive
                />
              </s.seekerWrapper>
            )}
          <s.bottomControls playerIsFullscreen={playerIsFullscreen}>
            <s.bottomControlsLeft playerIsFullscreen={playerIsFullscreen}>
              <Volume
                isMuted={isMuted}
                volume={player.volume}
                mute={player.mute}
                unMute={player.unMute}
                setVolume={player.setVolume}
                playerIsFullscreen={playerIsFullscreen}
                isMobile={isMobile}
                isVisible={isVisible}
              // onChangeStart={player.freezeOverlay}
              // onChangeEnd={this.unfreezeOverlay}
              />
              {isCCEnabled && playerIsFullscreen && !isEmbed && (
                <CCToggle
                  haveCaptions={haveCaptions}
                  captionIndex={captionIndex}
                  toggleCaption={toggleCaption}
                />
              )}
              {captionIndex === 0 && playerIsFullscreen && !isEmbed && (
                <Settings
                  onCCSettingsChange={onCCSettingsChange}
                  resetCCSettings={resetCCSettings}
                  onCCMenuOpen={onCCMenuOpen}
                  onCCMenuClose={onCCMenuClose}
                  onCCSubmenuOpen={onCCSubmenuOpen}
                  onCCSetIndex={onCCSetIndex}
                  isCCMenuOpen={isCCMenuOpen}
                  currentCCMenu={currentCCMenu}
                  currentCCMenuName={currentCCMenuName}
                  ccMenuSelectedIndexes={ccMenuSelectedIndexes}
                  showReset={showReset}
                  internalFullscreen={internalFullscreen}
                />
              )}
            </s.bottomControlsLeft>
            <s.bottomControlsRight playerIsFullscreen={playerIsFullscreen}>
              {captionIndex === 0 && playerIsFullscreen && isEmbed && (
                <Settings
                  onCCSettingsChange={onCCSettingsChange}
                  resetCCSettings={resetCCSettings}
                  onCCMenuOpen={onCCMenuOpen}
                  onCCMenuClose={onCCMenuClose}
                  onCCSubmenuOpen={onCCSubmenuOpen}
                  onCCSetIndex={onCCSetIndex}
                  isCCMenuOpen={isCCMenuOpen}
                  currentCCMenu={currentCCMenu}
                  currentCCMenuName={currentCCMenuName}
                  ccMenuSelectedIndexes={ccMenuSelectedIndexes}
                  showReset={showReset}
                  internalFullscreen={internalFullscreen}
                />
              )}
              {isCCEnabled && playerIsFullscreen && isEmbed && (
                <CCToggle
                  haveCaptions={haveCaptions}
                  captionIndex={captionIndex}
                  toggleCaption={toggleCaption}
                />
              )}
              {playerIsFullscreen && (
                <Share channel={channel} isTrivia={isTrivia} nowPlaying={nowPlaying} />
              )}
              <MobileOnly>
                {playerIsFullscreen && !isEmbed && (
                  <CollapsePlayer
                    onClick={
                      this.state.orientation === 'landscape' && isMobile
                        ? this.openPopup
                        : this.exitFullScreen
                    }
                  />
                )}
                <Dialog
                  open={this.state.popupOpen}
                  style={{ justifyContent: 'flex-end', alignItems: 'flex-end' }}
                  onClose={this.closePopup}
                  aria-describedby="alert-dialog-description"
                >
                  <DialogContent>
                    <DialogContentText style={{ color: 'black' }} id="alert-dialog-description">
                      {t('rotate_device', 'Please rotate your device to use this feature')}
                    </DialogContentText>
                  </DialogContent>
                </Dialog>
              </MobileOnly>
              {!player.isFullscreen && (
                <Fullscreen
                  isFullscreenDisabled={isFullscreenDisabled}
                  onClick={
                    isMobile
                      ? this.openPopup
                      : player.fullscreen
                  }
                />
              )}
              {player.isFullscreen && <ExitFullscreen onClick={player.exitFullscreen} />}
              {!hideTimes && <Time duration={duration / 1000} position={elapsed / 1000} />}
            </s.bottomControlsRight>
          </s.bottomControls>
        </s.bottomPanel>
        {!playerIsFullscreen && (
          <s.expandPlayer>
            <ExpandPlayer onClick={this.props.toggleFullscreen} />
          </s.expandPlayer>
        )}
      </s.videoControls>
    );
  }
}

const ChannelVideoControls = withStyles(styles)(withNamespaces()(ChannelVideoControlsComp));
export default withPlayer(ChannelVideoControls);
